import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import {
  Container,
  ContentContainer,
  Name,
  Row,
  Time,
  LeftSideInbox,
  Frame,
  RightSide,
  Inbox,
  ChatHeader,
  ChatInput,
  PaddingHorizontal,
  EmptyChat,
  Chat,
  ReceivedTime,
  ReceivedContainer,
  ReceivedMessage,
  Received,
  Sent,
  SentContainer,
  SentMessage,
  SentTime,
  Messages,
  ScrollContent,
  LoadingContainer,
  LeftLoadingContainer,
  Dot,
  Column,
  DetailsContainer,
  DotContainer,
  ChatRoomsContainer,
  StyledInput,
  IconContainer,
  AddIcon,
  Relative,
  Search,
  SearchIcon,
  ChooseFile,
  PhotoMedia,
  VideoMedia,
} from './InboxPage.styles';
import Sidebar from '../../components/Sidebar/Sidebar';
import Header from '../../components/Header/Header';
import { ReactComponent as ChatIcon } from '../../assets/icons/inbox.svg';
import { ReactComponent as X } from '../../assets/icons/closeModal.svg';
import { useDispatch, useSelector } from 'react-redux';
import {
  addMessageToChatRoom,
  resetSelectedChatRoom,
  selectAllChatRooms,
  selectChatRoom,
} from '../../store/slice/chat/slice';
import { getAllChatRooms, getChatRoom, postMediaMessage } from '../../store/slice/chat/asyncThunks';
import { dateTimeFullFormatter, timeFormatter } from '../../utils/utils';
import cryptoService from '../../services/cryptoService';
import { CHAT_MESSAGE_TYPES, SENDER_TYPE, SOCKET_EVENTS } from '../../utils/constants';
import { selectUserInfo } from '../../store/slice/vendor/slice';
import socketService from '../../services/socketService';
import { ReactComponent as Customer } from '../../assets/icons/customer.svg';
import InfiniteScroll from 'react-infinite-scroll-component';
import { Waveform } from '@uiball/loaders';
import HamburgerSidebar from '../../components/HamburgerSidebar/HamburgerSidebar';
import debounce from 'lodash.debounce';
import MediaModal from '../../components/Modal/MediaModal';

const selectedFrameClass = 'selected-frame';
const regularFrameClass = 'regular-frame';

const InboxPage = () => {
  const dispatch = useDispatch();

  const [selectedChat, setSelectedChat] = useState(null);
  const [lastMessageID, setLastMessageID] = useState(0);

  const chatRooms = useSelector(selectAllChatRooms);
  //const getAllChatRoomsPending = useSelector(selectGetAllChatRoomsPending);

  const selectedChatRoom = useSelector(selectChatRoom);
  const vendor = useSelector(selectUserInfo);
  const [newMessage, setNewMessage] = useState('');
  const { id, data, client, maxReached, page } = useSelector(selectChatRoom);
  const [loading, setLoading] = useState(false);
  const [allChatRoomsLoading, setAllChatRoomsLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [searchValue, setSearchValue] = useState('');

  const messagesRef = useRef();

  useEffect(() => {
    setAllChatRoomsLoading(true);
    dispatch(getAllChatRooms({ page: 1 }))
      .unwrap()
      .then(() => {
        setAllChatRoomsLoading(false);
      })
      .catch(err => {
        console.log(err);
      });
  }, [dispatch]);

  const showChat = item => {
    setLoading(true);
    setSelectedChat(item);
    dispatch(getChatRoom({ id: item.id, page: 1 }))
      .unwrap()
      .then(() => {
        setLoading(false);
        messagesRef.current?.scrollTo(0, messagesRef.current?.scrollHeight);
      })
      .catch(err => {
        console.log(err);
      });
  };

  const getNextPageOfChatRoom = () => {
    dispatch(getChatRoom({ id, page: page + 1 }));
  };

  const getNextPageChatRooms = () => {
    if (!chatRooms.maxReached) {
      dispatch(getAllChatRooms({ page: chatRooms.page + 1, search: searchValue }));
    }
  };

  const sendMessage = (message, doNotSend) => {
    const encrypted = cryptoService.encrypt(selectedChatRoom.key, message);
    const msg = {
      messageText: encrypted,
      senderId: vendor.id,
      type: CHAT_MESSAGE_TYPES.PLAIN_TEXT,
      chatRoomId: selectedChatRoom.id,
      customId: selectedChatRoom.id + '_' + (lastMessageID + 1),
      doNotSend,
      senderType: SENDER_TYPE.VENDOR,
      // userId: id,
    };
    const data = {
      message,
      createdAt: new Date().toISOString(),
      id: new Date().toISOString(),
      type: CHAT_MESSAGE_TYPES.PLAIN_TEXT,
      vendorId: vendor.id,
      status: 'sent',
      chatRoomId: selectedChatRoom.id,
    };

    dispatch(addMessageToChatRoom(data));

    setLastMessageID(prev => prev + 1);

    socketService.emit(SOCKET_EVENTS.SEND_MESSAGE, msg);
  };

  const onSendMessage = () => {
    if (newMessage) {
      sendMessage(newMessage);
    }
    setNewMessage('');
  };

  const unselectChatRoom = () => {
    dispatch(resetSelectedChatRoom());
    setSelectedChat(null);
  };

  const changeHandler = useCallback(
    text => {
      dispatch(getAllChatRooms({ page: 1, search: text }))
        .unwrap()
        .then(() => {})
        .catch(err => {
          console.log(err);
        });
    },
    [dispatch],
  );

  const debouncedChangeHandler = useMemo(() => debounce(changeHandler, 300), [changeHandler]);

  const handleSearch = e => {
    setSearchValue(e.target.value);
    debouncedChangeHandler(e.target.value);
  };

  const [openMediaModal, setOpenMediaModal] = useState(false);
  const [mediaUrl, setMediaUrl] = useState('');
  const [type, setType] = useState('');

  const handleFileChange = event => {
    let mediaType;
    if (
      event.target.files[0].type === 'image/jpeg' ||
      event.target.files[0].type === 'image/png' ||
      event.target.files[0].type === 'image/jpg'
    ) {
      mediaType = CHAT_MESSAGE_TYPES.PHOTO;
    } else if (event.target.files[0].type === 'video/mp4') {
      mediaType = CHAT_MESSAGE_TYPES.VIDEO;
    }

    const data = {
      message: { media: URL.createObjectURL(event.target.files[0]) },
      createdAt: new Date().toISOString(),
      id: new Date().toISOString(),
      type: mediaType,
      vendorId: vendor.id,
      status: 'sent',
      chatRoomId: selectedChatRoom.id,
    };
    dispatch(addMessageToChatRoom(data));
    dispatch(postMediaMessage({ message: event.target.files[0], chatRoomId: selectedChatRoom.id, type: mediaType }));

    setLastMessageID(prev => prev + 1);
  };

  return (
    <Container>
      <Sidebar />
      <HamburgerSidebar />
      <ContentContainer>
        <Header title={'Inbox'} />
        <Inbox>
          <LeftSideInbox id="scrollableDivChatRooms" $empty={!chatRooms.data.length}>
            {!allChatRoomsLoading ? (
              <ChatRoomsContainer>
                <StyledInput>
                  <IconContainer>
                    <SearchIcon />
                  </IconContainer>
                  <Search placeholder={'Search...'} value={searchValue} onChange={handleSearch} />
                </StyledInput>

                {chatRooms.data.length ? (
                  <InfiniteScroll
                    dataLength={chatRooms.data.length}
                    next={getNextPageChatRooms}
                    hasMore={!chatRooms.maxReached}
                    loader={
                      <LoadingContainer>
                        <Waveform size={25} lineWeight={3.5} speed={1} color="black" />
                      </LoadingContainer>
                    }
                    scrollableTarget="scrollableDivChatRooms">
                    {chatRooms.data.map(item => {
                      return (
                        <Frame
                          key={item.id}
                          onClick={() => showChat(item)}
                          className={
                            selectedChat && selectedChat.id === item.id ? selectedFrameClass : regularFrameClass
                          }>
                          <Column>
                            <DetailsContainer>
                              <Row>
                                {item.chatRoomMembers[0].user?.profilePhoto ? (
                                  <img
                                    src={item.chatRoomMembers[0].user?.profilePhoto}
                                    alt="profilePhoto"
                                    className="profilePhoto"
                                  />
                                ) : (
                                  <Customer />
                                )}

                                <Name>
                                  {item.chatRoomMembers[0].user?.firstName +
                                    ' ' +
                                    item.chatRoomMembers[0].user?.lastName}
                                </Name>
                              </Row>

                              <Time>{item.lastActivity && dateTimeFullFormatter(item.lastActivity)}</Time>
                            </DetailsContainer>
                            <DotContainer>{item.unseenMessage && <Dot />}</DotContainer>
                          </Column>
                        </Frame>
                      );
                    })}
                  </InfiniteScroll>
                ) : (
                  <EmptyChat>
                    <Name>You don't have any chats yet</Name>
                  </EmptyChat>
                )}
              </ChatRoomsContainer>
            ) : (
              <LeftLoadingContainer>
                <Waveform size={24} lineWeight={2.5} speed={1} color="black" />
              </LeftLoadingContainer>
            )}
          </LeftSideInbox>
          <RightSide>
            {!loading ? (
              <>
                {selectedChat ? (
                  <Chat>
                    <ChatHeader>
                      <Row>
                        {client.profilePhoto ? (
                          <img src={client.profilePhoto} alt="profilePhoto" className="profilePhoto" />
                        ) : (
                          <Customer />
                        )}
                        <Name>{client.firstName + ' ' + client.lastName}</Name>
                      </Row>
                      <X onClick={() => unselectChatRoom()} />
                    </ChatHeader>

                    <PaddingHorizontal>
                      <ScrollContent id="scrollableDiv" ref={messagesRef}>
                        {/* {selectedChatRoom.data.map(message => {
                      return (
                        <Messages key={message.id}>
                          {message.vendorId && (
                            <Sent>
                              <SentContainer>
                                <SentMessage>{message.message}</SentMessage>
                              </SentContainer>
                              <SentTime>{timeFormatter(message.createdAt)}</SentTime>
                            </Sent>
                          )}
                          {message.userId && (
                            <Received>
                              <ReceivedContainer>
                                <ReceivedMessage>{message.message}</ReceivedMessage>
                              </ReceivedContainer>
                              <ReceivedTime>{timeFormatter(message.createdAt)}</ReceivedTime>
                            </Received>
                          )}
                        </Messages>
                      );
                    })} */}

                        <InfiniteScroll
                          dataLength={data.length}
                          next={getNextPageOfChatRoom}
                          style={{ display: 'flex', flexDirection: 'column-reverse' }} //To put endMessage and loader to the top.
                          inverse={true}
                          hasMore={!maxReached}
                          loader={
                            <LoadingContainer>
                              <Waveform size={25} lineWeight={3.5} speed={1} color="black" />
                            </LoadingContainer>
                          }
                          scrollableTarget="scrollableDiv">
                          {data.map(message => {
                            return (
                              <Messages key={message.id}>
                                {message.vendorId && (
                                  <Sent>
                                    {message.type === CHAT_MESSAGE_TYPES.PLAIN_TEXT && (
                                      <SentContainer>
                                        <SentMessage>{message.message}</SentMessage>
                                      </SentContainer>
                                    )}
                                    {message.type === CHAT_MESSAGE_TYPES.PHOTO && (
                                      <PhotoMedia
                                        src={message.message.media}
                                        onClick={() => {
                                          setMediaUrl(message.message.media);
                                          setType('photo');
                                          setOpenMediaModal(true);
                                        }}
                                      />
                                    )}
                                    {message.type === CHAT_MESSAGE_TYPES.VIDEO && (
                                      <VideoMedia
                                        src={message.message.media}
                                        onClick={() => {
                                          setMediaUrl(message.message.media);
                                          setType('video');
                                          setOpenMediaModal(true);
                                        }}
                                      />
                                    )}
                                    <SentTime>{dateTimeFullFormatter(message.createdAt)}</SentTime>
                                  </Sent>
                                )}
                                {message.userId && (
                                  <Received>
                                    {message.type === CHAT_MESSAGE_TYPES.PLAIN_TEXT && (
                                      <ReceivedContainer>
                                        <ReceivedMessage>{message.message}</ReceivedMessage>
                                      </ReceivedContainer>
                                    )}
                                    {message.type === CHAT_MESSAGE_TYPES.PHOTO && (
                                      <PhotoMedia
                                        src={message.message.media}
                                        onClick={() => {
                                          setMediaUrl(message.message.media);
                                          setType('photo');
                                          setOpenMediaModal(true);
                                        }}
                                      />
                                    )}
                                    {message.type === CHAT_MESSAGE_TYPES.VIDEO && (
                                      <VideoMedia
                                        src={message.message.media}
                                        onClick={() => {
                                          setMediaUrl(message.message.media);
                                          setType('video');
                                          setOpenMediaModal(true);
                                        }}
                                      />
                                    )}
                                    <ReceivedTime>{dateTimeFullFormatter(message.createdAt)}</ReceivedTime>
                                  </Received>
                                )}
                              </Messages>
                            );
                          })}
                        </InfiniteScroll>
                      </ScrollContent>
                      <Relative>
                        <ChatInput
                          placeholder={'Type Something'}
                          value={newMessage}
                          onChange={text => setNewMessage(text.target.value)}
                          onSubmit={() => {}}
                          onKeyDown={e => e.key === 'Enter' && onSendMessage()}
                        />
                        <ChooseFile type="file" onChange={handleFileChange} />
                        <AddIcon />
                      </Relative>
                    </PaddingHorizontal>
                  </Chat>
                ) : (
                  <EmptyChat>
                    <ChatIcon width={40} height={40} />
                    <Name>Your messages</Name>
                    <Name>Send private messages to a client.</Name>
                  </EmptyChat>
                )}
              </>
            ) : (
              <LoadingContainer>
                <Waveform size={40} lineWeight={3.5} speed={1} color="black" />
              </LoadingContainer>
            )}
          </RightSide>
        </Inbox>
      </ContentContainer>
      <MediaModal open={openMediaModal} onClose={() => setOpenMediaModal(false)} mediaUrl={mediaUrl} type={type} />
    </Container>
  );
};

export default InboxPage;
